import React, { startTransition, useContext } from "react";
import './iconConnection.css'
import { AppContext } from "../../context/AppContext";
import { BsPersonCircle } from "react-icons/bs";
import ProfilLogin from "../profilLogin/profilLogin";
import { Link } from "react-router-dom";
import iconRestau from '../../image/icon/iconRestaurateur.webp'

interface IconConnectionProps {
    pointerClick?:() => void
}
const IconConnection:React.FC<IconConnectionProps> = ({pointerClick}) =>  {
    const {isLogin,setConnectionScreen,imgProfil} = useContext(AppContext)
    return (
        <div className="containerIconConnection" onPointerDown={(e) => {if (window.innerWidth <= 700 && pointerClick) {pointerClick();}}}>
            {
                isLogin === 0 ?
                    <div className="identification pointer lowOpacityHover" onClick={() => startTransition(() => {setConnectionScreen(true)})}>
                        <p className="XsmallText textLogin" id="identificationText">Connexion</p>
                        <BsPersonCircle size={30} className="logoUser" />
                    </div>
                    : isLogin === 1 ?
                        <ProfilLogin />
                        :
                        <Link to={"/restaurateurLogin"} className="imgProfilRestaurateur pointer" style={{  backgroundSize: "cover", backgroundPosition:'center',...(imgProfil ? {backgroundImage: `url(${imgProfil})`}:{}) }}>
                            {(!imgProfil || imgProfil === '') && <div className="iconChef" ><img src={iconRestau}  /></div>}
                        </Link>
            }
        </div>
    )
}

export default IconConnection